import { Flex, GridItem, Text } from "@chakra-ui/react";
import React from "react";
import { useTransactionsStore } from "../../../../store/transactionsStore";
import { OrderFilterSetting } from "../../../../types/order/orderQuery";
import { EmptyDataMessage } from "../../../atoms/EmptyDataMessage";
import { LoadingIndicator } from "../../../molecules/LoadingIndicator";

import { hasActiveFilters } from "./filters/hasActiveFilters";
import { MainTransactionTableRow } from "./MainTransactionTableRow";
import { useSelectedTxContext } from "./SelectedTxContext";

export function MainTransactionTableRows({
  onClickOrder,
  filters,
  gridColumns,
  totalTransactionCount,
}: {
  onClickOrder: (transactionId: string) => void;
  filters: OrderFilterSetting;
  gridColumns: number;
  totalTransactionCount?: number;
}) {
  const { isSelected, onSelect } = useSelectedTxContext();

  const groupList = useTransactionsStore((state) => state.groupList);
  const groupListTotal = useTransactionsStore((state) => state.groupListTotal);

  if (groupList === undefined) {
    return (
      <GridItem colSpan={gridColumns}>
        <LoadingIndicator content="Loading Transactions" />
      </GridItem>
    );
  }

  if (totalTransactionCount === 0) {
    return (
      <GridItem colSpan={gridColumns}>
        <EmptyDataMessage content="Add a data source to make the most of your Syla account" />
      </GridItem>
    );
  }

  if (groupList.length === 0) {
    // if the user just deleted all transactions on the page
    if (groupListTotal && groupListTotal > 0) {
      return (
        <GridItem colSpan={gridColumns}>
          <LoadingIndicator content="Loading Transactions" />
        </GridItem>
      );
    }

    if (hasActiveFilters(filters)) {
      return (
        <GridItem colSpan={gridColumns}>
          <Flex py={4} justify="center">
            <Text>No transactions in filter</Text>
          </Flex>
        </GridItem>
      );
    }
  }

  return (
    <>
      {groupList.map((groupId) => (
        <MainTransactionTableRow
          key={groupId}
          groupId={groupId}
          onSelect={onSelect}
          isSelected={isSelected(groupId)}
          onClickRow={onClickOrder}
          runningBalanceAssetId={
            filters.asset.length === 1 ? filters.asset[0] : undefined
          }
          useWalletBalance={filters.dataSource.length === 1}
        />
      ))}
    </>
  );
}
